import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';
import { addTooltipToStyledContent } from '../addTooltipToStyledContent';

const StyledContentOrderedList = ({ list }) => {
	const renderList = (orderedList, orderedCallback) => {
		switch (orderedList.listType) {
			case 'marked':
				return <ul>{orderedCallback(orderedList.items)}</ul>;
			case 'numeric':
				return <ol>{orderedCallback(orderedList.items)}</ol>;
			default:
				return null;
		}
	};

	const renderItems = (orderedItems) =>
		orderedItems.map((item, index) => {
			if (item.type === 'orderedListItem') {
				return (
					// eslint-disable-next-line react/no-array-index-key
					<li key={`${item.type}-${index}`}>
						{/* eslint-disable-next-line no-shadow */}
						{item.items.map((subItem, index) => {
							if (subItem.type === 'text') {
								return (
									<React.Fragment key={subItem.text.substring(0, 30)}>
										{parse(sanitize(subItem.text), {
											replace: addTooltipToStyledContent
										})}
									</React.Fragment>
								);
							}

							if (subItem.type === 'orderedList') {
								return (
									// eslint-disable-next-line react/no-array-index-key
									<React.Fragment key={`${subItem.type}-${index}`}>
										{renderList(subItem, renderItems)}
									</React.Fragment>
								);
							}

							return null;
						})}
					</li>
				);
			}

			if (item.listType) {
				return renderList(item, renderItems);
			}

			return null;
		});

	return renderList(list, renderItems);
};

StyledContentOrderedList.propTypes = {
	list: PropTypes.shape({
		listType: PropTypes.oneOf(['marked', 'numeric']).isRequired,
		items: PropTypes.arrayOf(
			PropTypes.shape({
				text: PropTypes.string,
				type: PropTypes.oneOf(['orderedList', 'orderedListItem']).isRequired
			})
		).isRequired
	})
};

export default StyledContentOrderedList;
